import { useState } from "react";
import { useTranslation } from "react-i18next";

const issues = (t) => ({
  engine_start: {
    label: t("diagnostic.issues.engine_start.title"),
    steps: [
      t("diagnostic.issues.engine_start.step1"),
      t("diagnostic.issues.engine_start.step2"),
      t("diagnostic.issues.engine_start.step3"),
      t("diagnostic.issues.engine_start.step4"),
    ],
    severe: true,
  },
  strange_noise: {
    label: t("diagnostic.issues.strange_noise.title"),
    steps: [
      t("diagnostic.issues.strange_noise.step1"),
      t("diagnostic.issues.strange_noise.step2"),
      t("diagnostic.issues.strange_noise.step3"),
    ],
    severe: true,
  },
  overheating: {
    label: t("diagnostic.issues.overheating.title"),
    steps: [
      t("diagnostic.issues.overheating.step1"),
      t("diagnostic.issues.overheating.step2"),
      t("diagnostic.issues.overheating.step3"),
      t("diagnostic.issues.overheating.step4"),
    ],
    severe: true,
  },
  soft_brakes: {
    label: t("diagnostic.issues.soft_brakes.title"),
    steps: [
      t("diagnostic.issues.soft_brakes.step1"),
      t("diagnostic.issues.soft_brakes.step2"),
      t("diagnostic.issues.soft_brakes.step3"),
    ],
    severe: true,
  },
  check_engine_light: {
    label: t("diagnostic.issues.check_engine_light.title"),
    steps: [
      t("diagnostic.issues.check_engine_light.step1"),
      t("diagnostic.issues.check_engine_light.step2"),
      t("diagnostic.issues.check_engine_light.step3"),
      t("diagnostic.issues.check_engine_light.step4"),
    ],
    severe: false,
  },
});

export default function QuickDiagnosticTool() {
  const { t } = useTranslation();
  const [selectedKey, setSelectedKey] = useState("");
  const [diagnosis, setDiagnosis] = useState(null);

  const allIssues = issues(t);

  const handleDiagnosis = () => {
    setDiagnosis(allIssues[selectedKey]);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-black p-6">
      <h1 className="text-2xl font-bold mb-4">{t("diagnostic.title")}</h1>
      <div className="w-full max-w-3xl bg-black p-6 rounded-xl shadow-lg text-white">
        <div>
          <select 
            className="w-full p-2 bg-gray-800 text-white rounded-md" 
            onChange={(e) => setSelectedKey(e.target.value)}
            value={selectedKey}
          >
            <option value="">{t("diagnostic.select")}</option>
            {Object.entries(allIssues).map(([key, issue]) => (
              <option key={key} value={key}>{issue.label}</option>
            ))}
          </select>
          <button 
            onClick={handleDiagnosis} 
            className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-md"
          >
            {t("diagnostic.button")}
          </button>
          {diagnosis && (
            <div className="mt-6">
              <h2 className="text-lg font-semibold">{t("diagnostic.steps")}</h2>
              <ul className="list-disc list-inside text-sm mt-2">
                {diagnosis.steps.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ul>
              {diagnosis.severe && (
                <p className="mt-4 text-red-500 font-bold">{t("diagnostic.severe_warning")}</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
